var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "520",
      "persistent": _vm.loading
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-card', _vm._b({
    attrs: {
      "light": ""
    }
  }, 'v-card', {
    loading: _vm.loading
  }, false), [_c('v-card-title', [_vm._v(" 취소표기 "), _c('v-spacer'), _c('v-icon', {
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": function click($event) {
        _vm.shows = false;
      }
    }
  }, [_vm._v("mdi-close")])], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "pt-4 body-2"
  }, [_c('div', [_vm._v("결제사에서 이미 환불된 주문을 취소완료로 바꿉니다.")]), _c('ul', {
    staticClass: "mt-2"
  }, [_c('li', [_vm._v("결제사 환불은 다시 부르지 않습니다.")]), _c('li', [_vm._v("표기한 주문은 결제일 매출에서 빠집니다. 지난 기간 매출 숫자도 바뀝니다.")]), _c('li', {
    staticClass: "error--text"
  }, [_vm._v("되돌릴 수 없습니다.")])]), _c('v-radio-group', {
    staticClass: "mt-4",
    attrs: {
      "disabled": _vm.loading,
      "hide-details": ""
    },
    model: {
      value: _vm.voidPins,
      callback: function callback($$v) {
        _vm.voidPins = $$v;
      },
      expression: "voidPins"
    }
  }, [_c('v-radio', {
    attrs: {
      "value": false
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('div', [_c('div', [_vm._v("상태만 바꾸기")]), _c('div', {
          staticClass: "caption grey--text"
        }, [_vm._v("핀은 그대로 둡니다. 아직 살아 있는 핀은 고객이 핀번호로 계속 충전할 수 있습니다. (나누리핀에서 이미 폐기된 핀은 해당 없음)")])])];
      },
      proxy: true
    }])
  }), _c('v-radio', {
    staticClass: "mt-2",
    attrs: {
      "value": true,
      "disabled": !_vm.ungainedCount
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('div', [_c('div', [_vm._v("핀도 폐기하기")]), _vm.ungainedCount ? _c('div', {
          staticClass: "caption grey--text"
        }, [_vm._v("충전하지 않은 핀 " + _vm._s(_vm.ungainedCount) + "장 중 나누리핀에서 아직 사용·폐기되지 않은 핀만 폐기합니다. 이미 폐기된 핀은 건너뜁니다. 실제로 폐기한 핀만 나누리핀 정산이 되돌려집니다.")]) : _c('div', {
          staticClass: "caption grey--text"
        }, [_vm._v("충전하지 않은 핀이 없습니다.")])])];
      },
      proxy: true
    }])
  })], 1)], 1), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "disabled": _vm.loading
    },
    on: {
      "click": function click($event) {
        _vm.shows = false;
      }
    }
  }, [_vm._v(" 닫기 ")]), _c('v-btn', {
    attrs: {
      "color": "error",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 취소표기 ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }